import { slotConfs } from "../../../../constant/initDrawing";
import RandomQuestion from "../../../results/randomQuestion";
import RanderSlot from "../RenderSlot";
import React from "react";

function DrawingTable({ result, config, currentResult, setResult }) {

    const getResults = result.results.filter((_, i) => ![(result.results.length - 2), (result.results.length - 1)].includes(i));

    const onAfterReleaseCallback = () => setResult(currentResult);

    return (<div className="w-50  d-flex justify-content-end">
        <table style={{
            width: "810px"
        }} className="">
            <tbody>
                {getResults.map((res, j) => {
                    const hlBG = config.ng.hlIndex.includes(j);
                    const rowTd = config.ng.row[`row_td_${j}`];
                    const rowBg = config['row_' + j];

                    const style = {
                        background: rowBg ? rowBg : hlBG ? config.hlBG : config.background
                    }

                    return <React.Fragment key={j}>
                        {j === 0 ? <tr style={style} className={`row-${j}`}>
                            <td align="middle" key={`${j}`}>
                                <RanderSlot
                                    currentResult={currentResult}
                                    index={0}
                                    isNight={true}
                                    onAfterReleaseCallback={onAfterReleaseCallback}
                                    config={slotConfs} />
                            </td>
                        </tr>
                            : <tr style={style} className={`row-${j}`} key={j}>
                                <td style={rowTd}>
                                    <div className="d-flex justify-content-center align-items-start h-100">
                                        {res.items.map((list, i) => {
                                            const style = config.ng.row[`row_${j}`];
                                            const styleBox = config.ng[`row_box_${j}`];
                                            const styleItem = config.ng[`row_item_${j}`];
                                            return <div style={styleBox} align="middle" key={`${j}_${i}`}>
                                                {list.map((num, index) => {
                                                    if (num.includes("*")) {
                                                        return <div key={index} />
                                                    }
                                                    if (num.includes("?")) {
                                                        let randomSt = style?.random ? {
                                                            ...style.random,
                                                            color: "#DD0000",
                                                            background: config.random.background
                                                        } : config.random
                                                        return <div key={index} style={styleItem}>
                                                            <RandomQuestion className="random-res animate-kp-r" style={randomSt}
                                                                sizeDigit={num.length} />
                                                        </div>
                                                    }
                                                    return <div className="" style={{ ...style?.normal, ...styleItem }}
                                                        key={index}>{num}</div>
                                                })}
                                            </div>
                                        })}
                                    </div>
                                </td>
                            </tr>}
                    </React.Fragment>
                })}
            </tbody>
        </table>
    </div>);
}

export default DrawingTable;